import apiHandler from "../core/apiHandler";

// 📌 Todas las rutas estarán bajo /api/routes
const routesApi = apiHandler("routes");

export default routesApi;
